'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

const TRACING_URLS = {
  API: process.env.TOWN_API_URL,
  SERVER: '/api',
} as const;

const getTracingUrls = (): string[] => {
  const urls = [TRACING_URLS.API, TRACING_URLS.SERVER];

  return urls.filter((url): url is string => Boolean(url));
};

const DatadogInitializer = () => {
  useEffect(() => {
    if (process.env.CURRENT_ENV !== 'local') {
      datadogRum.init({
        applicationId: process.env.TOWN_WEB_DATADOG_APPLICATION_ID || '',
        clientToken: process.env.TOWN_WEB_DATADOG_CLIENT_TOKEN || '',
        site: 'datadoghq.com',
        service: process.env.TOWN_WEB_DATADOG_SERVICE,
        env: process.env.CURRENT_ENV,
        version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: getTracingUrls(),
      });
    }
  }, []);

  return null;
};

export default DatadogInitializer;
